jQuery(document).ready(function ($) {
  // only if on `cart` page
  if (!$('body').hasClass('woocommerce-cart')) return

  // Toggle 'Initial Shipment' section
  toggleShippingSection(
    '.bgf_shipping-tab svg',
    'Initial Shipment',
    '#shipping_method'
  )

  // Toggle 'Shipping' section for recurring shipping
  toggleShippingSection(
    '.bgf_shipping-tab-recurring svg',
    'Shipping',
    '.shipping_method_recurring'
  )

  // Toggle 'Shipping' section for general shipping
  toggleShippingSection(
    '.bgf_shipping-tab svg',
    'Shipping',
    '#shipping_method'
  )

  // Insert a custom divider before the PPC button wrapper
  $('<div class="em-dash-or">&mdash; OR &mdash;</div>').insertBefore(
    '.ppc-button-wrapper'
  )

  // Reformat product titles
  $('.woocommerce-cart-form__cart-item.cart_item .bgf_product-title>span').each(
    function () {
      var items = $(this).text().split(', ')
      var newContent = items[0]
      for (var i = 1; i < items.length; i++) {
        newContent += '<br>&nbsp;- ' + items[i]
      }
      $(this).html(newContent)
    }
  )

  // Generalized toggle functionality for shipping sections
  function toggleShippingSection(selector, dataTitle, methodSelector) {
    // Ensure the section is open on page load
    $(`[data-title="${dataTitle}"]`).show()

    // Set the initial state of the SVG transform
    var svg = $(selector)
    svg.css('transform', 'scaleY(-1)')

    $(document).on('click', selector, function () {
      $(`[data-title="${dataTitle}"]`).slideToggle(400, function () {
        svg.css(
          'transform',
          $(methodSelector).is(':visible') ? 'scaleY(-1)' : 'scaleY(1)'
        )
      })
    })
  }

  // WooCommerce AJAX event hook for updating shipping methods
  $(document.body).on('updated_shipping_method', function () {
    // Reload the page
    location.reload()
  })

  // WooCommerce AJAX event hook for removing a cart item
  $(document.body).on('removed_from_cart', function () {
    // Reload the page
    location.reload()
  })

  // WooCommerce AJAX event hook for updating cart fragments
  $(document.body).on('wc_update_cart', function () {
    $.ajax({
      url: wpData.wc_ajax_url
        .toString()
        .replace('%%endpoint%%', 'get_refreshed_fragments'),
      type: 'POST',
      success: function (response) {
        if (response && response.fragments) {
          $.each(response.fragments, function (key, value) {
            $(key).replaceWith(value)
          })
          $(document.body).trigger('wc_fragments_refreshed')
        }
      },
    })
    location.reload()
  })
})
